import theme from "app/Theme/Theme";
import React, { memo } from "react";
import { StyleSheet, View, TouchableOpacity } from "react-native";
import RatingStar from "../../../scenes/FeedbackScreen/ReflexiveAnalysis/ActionRatingScreen/RatingStar";
import normalize from "app/utils/normalize";
import { PressableOpacity } from "app/components/common";

const STAR_HEIGHT = normalize(24);
const STAR_WIDTH = normalize(24);

const styles = StyleSheet.create({
  badgeView: {
    zIndex: 0,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 40,
    width: "33%",
    height: 100,
  },
  starView: {
    flexDirection: "row",
    marginTop: theme.spacing.xs,
  },
});

const Badge = ({ onPress, level, BadgeIcon }) => {
  return (
    <PressableOpacity
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      marginBottom="l"
      width="33%"
      height={100}
      onPress={onPress}
    >
      {BadgeIcon}
      <View style={styles.starView}>
        <RatingStar
          isFill={level > 0}
          setRating={onPress}
          height={STAR_HEIGHT}
          width={STAR_WIDTH}
        />
        <RatingStar
          isFill={level > 1}
          setRating={onPress}
          height={STAR_HEIGHT}
          width={STAR_WIDTH}
        />
        <RatingStar
          isFill={level > 2}
          setRating={onPress}
          height={STAR_HEIGHT}
          width={STAR_WIDTH}
        />
      </View>
    </PressableOpacity>
  );
};

export default memo(Badge);
